import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { CodeTitle, ICodeTitle } from "../common/codeTitle";
import { IPagePanel } from "../common/pagePanel";
import { RecordPagePanel } from "../record/recordPagePanel";

export interface IRiskPageData {
    canCreateRisks: boolean;
    canEditModuleProperties: boolean;
    canEditAllModuleProperties: boolean;
    panels: IPagePanel[];
    units: IIdTitleNode[];
    states: INumberTitle[];
    riskCategories: IIdTitleNode[];
    riskProcesses: IIdTitleNode[];
    riskStandards: IIdTitleNode[];
    riskStakeholders: IIdTitleNode[];
    handlers: ICodeTitle[];
    owners: string[];
}

export class RiskPageData implements IRiskPageData {
    canCreateRisks: boolean;
    canEditModuleProperties: boolean;
    canEditAllModuleProperties: boolean;
    panels: RecordPagePanel[];
    units: IdTitleNode[];
    states: NumberTitle[];
    riskCategories: IdTitleNode[];
    riskProcesses: IdTitleNode[];
    riskStandards: IdTitleNode[];
    riskStakeholders: IdTitleNode[];
    handlers: CodeTitle[];
    owners: string[];

    constructor();
    constructor(obj: IRiskPageData);
    constructor(obj?: any) {
        this.canCreateRisks = obj?.canCreateRisks ?? false;
        this.canEditModuleProperties = obj?.canEditModuleProperties ?? false;
        this.canEditAllModuleProperties = obj?.canEditAllModuleProperties ?? false;
        this.panels = Base.getTypedArray(obj?.panels, RecordPagePanel);
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
        this.states = Base.getTypedArray(obj?.states, NumberTitle);
        this.riskCategories = Base.getTypedArray(obj?.riskCategories, IdTitleNode);
        this.riskProcesses = Base.getTypedArray(obj?.riskProcesses, IdTitleNode);
        this.riskStandards = Base.getTypedArray(obj?.riskStandards, IdTitleNode);
        this.riskStakeholders = Base.getTypedArray(obj?.riskStakeholders, IdTitleNode);
        this.handlers = Base.getTypedArray(obj?.handlers, CodeTitle);
        this.owners = obj?.owners || [];
    }
}
